var _g;

const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

const SvgIconRefund = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-30 -30)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#454e4f",
    d: "M50.25,43.5h-.024a6.379,6.379,0,0,0-5.768,4H43a1,1,0,0,0,0,2h1.01Q44,49.749,44,50t.01.5H43a1,1,0,0,0,0,2h1.459a6.379,6.379,0,0,0,5.768,4h1.346a1,1,0,0,0,0-2H50.263a4.38,4.38,0,0,1-3.562-2H49a1,1,0,0,0,0-2H46.015A4.355,4.355,0,0,1,46,50.023q0-.023,0-.046a4.355,4.355,0,0,1,.015-.477H50a1,1,0,0,0,0-2H46.7a4.38,4.38,0,0,1,3.562-2h1.309a1,1,0,0,0,0-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#454e4f",
    d: "M50,38A12,12,0,1,0,62,50,12,12,0,0,0,50,38ZM40,50A10,10,0,1,1,50,60,10,10,0,0,1,40,50Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#98c11d",
    d: "M49,34a1,1,0,0,1,1-1,17,17,0,0,1,0,34,1,1,0,0,1,0-2,15,15,0,0,0,0-30A1,1,0,0,1,49,34Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#98c11d",
    d: "M50.707,31.293a1,1,0,0,1,0,1.414L49.414,34l1.293,1.293a1,1,0,0,1-1.414,1.414l-2-2a1,1,0,0,1,0-1.414l2-2A1,1,0,0,1,50.707,31.293Z"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconRefund, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-refund.bc909cb4.svg";
export { ForwardRef as ReactComponent };